export { default } from './AddPatientPopup';
